import {
    NumberFormatBase,
    NumericFormatProps,
    useNumericFormat,
} from "react-number-format";

interface Props extends NumericFormatProps {
    prefix?: string;
    suffix?: string;
    allowEmptyFormatting?: boolean;
}

export const NumberFormat = (props: Props) => {
    const { prefix = "", suffix = "", allowEmptyFormatting } = props;
    const { format, ...numberFormatBaseProps } = useNumericFormat(props);
    const _format = (numStr: string) => {
        const formattedValue = format?.(numStr) ?? "";
        return allowEmptyFormatting && formattedValue === ""
            ? prefix + suffix
            : formattedValue;
    };

    return <NumberFormatBase {...numberFormatBaseProps} format={_format} />;
};
